
import Accordion from '@/ui-kit/components/accordion';
import { AccordionSlotName, AccordionProperty } from '@/ui-kit/components/accordion/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ListingPreviewAccordionHeader from './header';
import ListingPreviewAccordionContent from './content';

export default {
  name: 'ListingPreviewAccordion',
  components: {
    Accordion,
    ListingPreviewAccordionHeader,
    ListingPreviewAccordionContent,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    isDraftStatus: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      required: true,
    },
    isUserTitleHolder: {
      type: Boolean,
      required: true,
    },
    isUserAdmin: {
      type: Boolean,
      default: false,
    },
    hasAgreement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AccordionSlotName,
      AccordionProperty,
    };
  },
  computed: {
    accordionStatusSettings() {
      return {
        colorScheme: StyleColorSchemeType.White,
      };
    },
  },
};
